import type { ErrorStrategy } from '../types';
import { t } from 'i18next';

export const requiredStrategy: ErrorStrategy = ({ instancePath, params: { missingProperty } }) => {
  return {
    path: `${instancePath}/${missingProperty}`,
    message: t('Validation.PropertyRequired'),
  };
};
